import { Card, Row, Col } from 'react-bootstrap'
import Reviews from './Reviews.js'

const Testomonial = () => {
    return (
        <>
            <div className="Testomonial position-relative overflow-hidden p-3 p-md-3 text-center">
                <div className="col-md-11 p-lg-5 mx-auto my-5 fw-bold">
                    <h2 className="display-5 fw-bolder mb-4 text-center text-danger Testomonial-title"
                        data-aos="zoom-out-up">Good Reviews by Our Clients</h2>
                    <Row xs={1} md={1} lg={4} className="d-flex justify-content-center">
                        {Reviews.map((review) => (
                            <Col xs={10} md={10} lg={4} className="my-3" key={review.id}>
                                <Card className="cards p-3 rounded-0"
                                    data-aos="fade-down" data-aos-delay="500" data-aos-duration="2000">
                                    <Card.Body>
                                        <Card.Title className="testomonial_title">{review.name}</Card.Title>
                                        <Card.Text>{review.image}</Card.Text>
                                        <Card.Text className="testomonial_review">
                                            {review.review}
                                        </Card.Text>
                                        <div className="rating text-warning">
                                            {review.rating}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
                <div className="product-device shadow-sm d-none d-md-block"></div>
                <div className="product-device product-device-2 shadow-sm d-none d-md-block"></div>
            </div>
        </>
    )
}

export default Testomonial